import React from 'react';

interface Props {
    value: number,
    type: string,
    onValueChange: (value: number) => void,
    size: number
}
export default function PlusMinus(props: Props) {
    switch (props.type) {
        /*case 'cart':
            return (<div style={{ flex: 1, flexDirection: 'row', justifyContent: 'center', alignItems: 'baseline', height: props.size + 10 }}>
                <button
                    style={{ borderRadius: 3, backgroundColor: 'black', padding: 5, alignItems: 'center', width: props.size + 10, height: props.size + 10 }}
                    onClick={() => { props.onValueChange(-1) }}>
                    <i className="fa fa-minus" style={{ flex: 1, color: 'white' }} />
                </button>
                <label style={{ flex: 1, textAlign: 'center', fontSize: props.size, lineHeight: props.size }}>{props.value}</label>
                <button
                    style={{ borderRadius: 3, backgroundColor: 'black', padding: 5, alignItems: 'center', width: props.size + 10, height: props.size + 10 }}
                    onClick={() => { props.onValueChange(1) }}>
                    <i className="fa fa-plus" style={{ flex: 1, color: 'white' }} />
                </button>
            </div >
            )*/
        default:
            return (<div className='product-plus-minus'>
                <button disabled={props.value === 1}
                    style={{  opacity: props.value === 1 ?0.5 : 1}}
                    onClick={() => { props.onValueChange(-1) }}>
                    <i className="fa fa-minus" />
                </button>
                <label>{props.value}</label>
                <button
                    onClick={() => { props.onValueChange(1) }}>
                    <i className="fa fa-plus" />
                </button>
            </div >
            )
    }
}